import React, { useEffect, useMemo } from "react";
import { getErrorDetails } from "../../../app/appUtils";
import { MySelect } from "../../../components/ui/Select";
import { cn } from "../../../lib/utils";
import { Brand } from "../@types";
import { useGetBrandsMutation } from "../brandApiSlice";

interface BrandDropdownMenuProps {
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
  disabled?: boolean;
  placeholder?: string;
  name?: string;
  id?: string;
  showLabel?: boolean;
  label?: string;
  error?: string;
}

interface BrandOption {
  value: string;
  label: string;
}

const BrandDropdownMenu: React.FC<BrandDropdownMenuProps> = ({
  value,
  onChange,
  className,
  disabled,
  placeholder = "Brand",
  name = "brands",
  id = "brands",
  showLabel = true,
  error,
  label,
}) => {
  const [getBrands, { data: brands, isLoading, isError, error: errorData }] =
    useGetBrandsMutation();

  console.log("BrandDropdownMenu - brands data:", brands);

  const brandsData = useMemo(() => {
    return brands?.data || [];
  }, [brands?.data]);

  useEffect(() => {
    getBrands({
      pageNumber: 0,
      pageSize: 100,
    });
  }, [getBrands]);

  const driversOptions: BrandOption[] = useMemo(() => {
    if (isLoading) {
      return [{ value: "", label: "Loading..." }];
    }

    if (isError) {
      return [{ value: "", label: "Error loading brands" }];
    }

    return brandsData.map((brand: Brand) => ({
      value: brand.id,
      label: `${brand.name}`,
    }));
  }, [brandsData, isLoading, isError]);

  const handleValueChange = (option: BrandOption) => {
    onChange?.(option.value);
  };

  // Helper functions for MySelect
  const getValue = (option: BrandOption) => option.value;
  const getName = (option: BrandOption) => option.label;

  return (
    <div className={cn("w-full")}>
      <MySelect<BrandOption>
        name={name}
        id={id}
        label={showLabel ? label || "Brand" : ""}
        options={driversOptions}
        getValue={getValue}
        getName={getName}
        value={value}
        onChange={onChange}
        onValChange={handleValueChange}
        placeholder={placeholder}
        disabled={disabled || isLoading || isError}
        className={cn(
          "focus:ring-primary focus:border-primary",
          {
            "opacity-50": isLoading,
          },
          className,
        )}
        // showSearch={true}
      />

      {isError && (
        <p className="mt-1 text-sm text-red-500" role="alert">
          {getErrorDetails(errorData)?.message || "Error loading brands"}
        </p>
      )}

      {error && (
        <p className="mt-1 text-sm text-red-500" role="alert">
          {error}
        </p>
      )}
    </div>
  );
};

export default BrandDropdownMenu;
